import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vestuario',
  templateUrl: './vestuario.component.html',
  styleUrls: ['./vestuario.component.scss']
})
export class VestuarioComponent implements OnInit {

  navbarCategorias: boolean;

  constructor() {
    this.navbarCategorias = false;
  }

  ngOnInit() {
  }

  scroll(id) {
    var element = document.getElementById(id);
    window.scroll({ top: element.offsetTop, left: 0, behavior: 'smooth' });
  }

  navbarToogle(toogle) {
    this.navbarCategorias = toogle;
  }

}
